var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple__block" }, [
        _c(
          "div",
          { staticClass: "order__block_info" },
          [
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-auto" }, [
                  _c("p", [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant(
                            "text_tracking_number_full"
                          )
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "order__traking_number",
                        attrs: { href: "#" },
                      },
                      [_vm._v(_vm._s(_vm.parcel.track_code))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "copy__traking_number" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z",
                              fill: "#06C",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "copy__traking_alert" }, [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_copied_to_clipboard"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_flight")) +
                          ":"
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.getOrderFlight(_vm.parcel)) +
                        "\n                        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-auto pl-md-5" }, [
                  _c("p", [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_arrival_date")
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.parcel.date))]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_bar_code")) +
                          ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "javascript:void(0)" } }, [
                      _vm._v(
                        _vm._s(
                          typeof _vm.parcel.bar_code !== "undefined" &&
                            typeof _vm.parcel.bar_code !== null
                            ? _vm.parcel.bar_code
                            : "-"
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            _vm._v(" "),
            _c("div", { staticClass: "order__print" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z",
                      fill: "#515154",
                    },
                  }),
                ]
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c("table", { staticClass: "table table__arrived__item__orders" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.get_translation_constant("text_weight"))),
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v(_vm._s(_vm.get_translation_constant("text_rate"))),
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant("text_additional_services")
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.parcelNotPaidBill
                ? _c("th", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.get_translation_constant("text_customs_tax")
                        ) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("th", [
                _vm._v(_vm._s(_vm.get_translation_constant("text_total"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c(
              "tr",
              [
                _c(
                  "td",
                  {
                    attrs: {
                      "data-label": _vm.get_translation_constant("text_weight"),
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.parcel.weight) +
                        _vm._s(_vm.get_translation_constant("text_kg")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                [
                  _c(
                    "td",
                    {
                      attrs: {
                        "data-label": _vm.get_translation_constant("text_rate"),
                      },
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.parcel.tariff_to_kg))])]
                  ),
                ],
                _vm._v(" "),
                (_vm.parcel.services !== null &&
                  _vm.parcel.services.length > 0) ||
                (_vm.parcel.solutions !== null &&
                  _vm.parcel.solutions.length > 0)
                  ? _c(
                      "td",
                      {
                        attrs: {
                          "data-label": _vm.get_translation_constant(
                            "text_additional_services"
                          ),
                        },
                      },
                      [
                        _c("strong", [_vm._v(_vm._s(_vm.totalServicesSum))]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "tooltip__block tooltip__bottom tooltip__modal",
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "tooltip__block_trigger" },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 14 14",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                        fill: "#515154",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "tooltip__block_overlay" },
                              [
                                _c("span", {
                                  staticClass:
                                    "tooltip__block_inner tooltip__small",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.getServicesPrices),
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "td",
                      {
                        attrs: {
                          "data-label": _vm.get_translation_constant(
                            "text_additional_services"
                          ),
                        },
                      },
                      [_vm._v("-")]
                    ),
                _vm._v(" "),
                _vm.parcelNotPaidBill
                  ? _c("td", [
                      _c(
                        "strong",
                        { class: [_vm.billStatusClass, "customs-error"] },
                        [_vm._v(_vm._s(_vm.parcel.bill.amount) + "$")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "tooltip__block tooltip__bottom tooltip__modal",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "tooltip__block_trigger" },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 14 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                      fill: "#515154",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "tooltip__block_overlay" },
                            [
                              _c("span", {
                                staticClass:
                                  "tooltip__block_inner tooltip__small",
                                domProps: {
                                  innerHTML: _vm._s(_vm.billInfo.title),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.parcel.total_price !== null
                  ? _c(
                      "td",
                      {
                        attrs: {
                          "data-label":
                            _vm.get_translation_constant("text_total"),
                        },
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.parcel.total_price) + "$"),
                        ]),
                      ]
                    )
                  : _c(
                      "td",
                      {
                        attrs: {
                          "data-label":
                            _vm.get_translation_constant("text_total"),
                        },
                      },
                      [_vm._v("-")]
                    ),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.parcelHasWaitingDocumentRequest
          ? _c(
              "div",
              {
                staticClass: "d-md-flex",
                class: _vm.parcelDocumentRequestData.class,
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.parcelDocumentRequestData.content) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.parcelHasDocumentRequest || _vm.parcelHasBill
        ? _c(
            "div",
            { staticClass: "simple__block" },
            [
              _c("h3", [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant(
                      "text_customs_payment_confirmation"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.parcelHasBill
                ? _c("div", { staticClass: "form-check form-switch" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.not_accept_bill,
                          expression: "not_accept_bill",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        checked: "",
                        id: "acceptBill",
                        name: "notification",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.not_accept_bill)
                          ? _vm._i(_vm.not_accept_bill, null) > -1
                          : _vm.not_accept_bill,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.not_accept_bill,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.not_accept_bill = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.not_accept_bill = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.not_accept_bill = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "acceptBill" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_customs_tax_less"
                            )
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUpload",
                attrs: {
                  files_array: _vm.serverFiles,
                  multiple: true,
                  translations: _vm.translations,
                  ajax: false,
                  lng: _vm.lng,
                  upload_files_link: _vm.upload_files_link,
                  delete_files_link: _vm.delete_files_link,
                  additional_ajax_params: { parcel_id: _vm.parcel.id },
                  downloadlink: _vm.downloadlink,
                  template: "arrived",
                },
                on: {
                  childToParent: function ($event) {
                    return _vm.setFiles($event, "files")
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__col" }, [
                _c("label", { attrs: { for: "comments" } }, [
                  _vm._v(_vm._s(_vm.get_translation_constant("text_comment"))),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.comment,
                      expression: "comment",
                    },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    name: "comments",
                    id: "comments",
                    placeholder: _vm.get_translation_constant("text_comment"),
                  },
                  domProps: { value: _vm.comment },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.comment = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-end" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn__large btn__blue",
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.sendConfirmation()
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.get_translation_constant("text_send_confirmation")
                      )
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "block-message-history" }, [
                _c(
                  "div",
                  { staticClass: "block-content" },
                  [
                    _c("h4", { staticClass: "h_text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_message_history")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.comments, function (comment, key) {
                      return _c("customs-comment", {
                        key: key,
                        attrs: { comment: comment, account: _vm.account },
                      })
                    }),
                  ],
                  2
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.parcel.pictures.length
        ? _c(
            "div",
            { staticClass: "simple__block mt-4" },
            [
              _c("file-upload", {
                ref: "fileUpload",
                attrs: {
                  files_array: _vm.serverPictures,
                  multiple: true,
                  translations: _vm.translations,
                  ajax: false,
                  lng: _vm.lng,
                  upload_files_link: _vm.upload_files_link,
                  delete_files_link: _vm.delete_files_link,
                  additional_ajax_params: { parcel_id: _vm.parcel.id },
                  downloadlink: _vm.downloadlink,
                  template: "preview-photo",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: {
          title: _vm.modalTitle,
          type: _vm.modalType,
          message: _vm.modalMessage,
          modalId: _vm.modalId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }